import Vue from 'vue';
import { Module } from 'vuex';

import { Course, CoursesListState, RootState } from 'frontend/types';

const recentCourses: Module<CoursesListState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as Course[],
  }),
  mutations: {
    setValue(state: CoursesListState, value: Course[]): void {
      Vue.set(state, 'items', value);
    },
    setNotifyComingSoon(state, { courseId, notifyWhenPublished }) {
      state.items.forEach(c => {
        if (c.course_id === courseId) {
          c.notify_when_published = notifyWhenPublished;
        }
      });
    },
    addRecommendedCourses(state, courses: Course[]) {
      state.items = [...state.items, ...courses];
    },
  },
  getters: {
    recentCourses(state: CoursesListState): Course[] {
      return state.items;
    },
  },
};

export default recentCourses;
